<template>
  <modal :show="show" header-classes="justify-content-center" @close="handleClose()">
    <BSA
      ref="childBSAComponent"
      :attendance="attendance"
      :title="null"
      :can-cancel="true"
      :show-met-at="true"
      :is-embedded-in-modal="true"
      @returnBSAData="saveBSA($event)"
    />
  </modal>
</template>

<script>
import {
    mapState, mapGetters, vuex
} from 'vuex';
import BSA from './Attendance';
import modal from '../../UIComponents/Modal';

export default {
    name: 'EditBSAModal',
    components: {
        modal,
        BSA
    },
    data() {
        return {
            namespace: 'BibleStudies',
        };
    },
    props: {
        show: Boolean,
        attendance: Object,
    },
    computed: {
        ...mapState({
            error: (state) => state.BibleStudies.error,
        }),
    },
    methods: {
        saveBSA(BSAData) {
            this.$store.dispatch(`${this.namespace}/updateBibleStudyAttendance`, {
                attendance_data: BSAData,
            }).then(this.handleClose());
        },
        handleClose() {
            // Resets the BSA component data
            this.$refs.childBSAComponent.handleClose();
            this.$emit('close');
        },
    },
};
</script>

<style>
</style>
